import { render, staticRenderFns } from "./20.vue?vue&type=template&id=2095be8c&scoped=true&"
import script from "./20.vue?vue&type=script&lang=js&"
export * from "./20.vue?vue&type=script&lang=js&"
import style0 from "./20.vue?vue&type=style&index=0&id=2095be8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095be8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2095be8c')) {
      api.createRecord('2095be8c', component.options)
    } else {
      api.reload('2095be8c', component.options)
    }
    module.hot.accept("./20.vue?vue&type=template&id=2095be8c&scoped=true&", function () {
      api.rerender('2095be8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/20.vue"
export default component.exports